import * as React from "react"
import { Box, Typography } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"


export default function ReportsManagementNoReportDataBlock() {
    const boxStyles = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        bgcolor: 'background.paper',
        padding: 3,
        borderRadius: 2,
        boxShadow: 2,
        textAlign: 'center',
    }

    return <Box sx={boxStyles}>
        <IconSeeker icon={'database'} sx={{ fontSize: 40, color: 'text.secondary', mb: 1 }} />

        <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: 'text.primary', mt: 1 }}>
            No data available.
        </Typography>

        <Typography variant="body2" sx={{ color: 'text.secondary',  mt: 1 }}>
            Please configure a report to view insights.
        </Typography>
    </Box>
}